import list from "list.js";

export default class JobOffers {
    constructor() {
        this.initBlock()
    }

    initBlock() {
        const block = document.querySelector('.job-offers');
        if (!block) {
            return;
        }
        const options = {
            valueNames: [ 'title', 'city' ]
        };

        new list(block, options);
    }

}
  

